export default __webpack_public_path__ + "static/media/logo.9ea7ffc2.png";